import { Modal, Table, Badge } from "flowbite-react";

const RequestActivityModal = ({
    show,
    onClose,
    requestActivityData
}) => {
    return (
        <Modal show={show} onClose={onClose} popup>
            <Modal.Header />
            <Modal.Body>
                <h3 className="text-xl font-medium text-gray-900 pb-2">Request Activities</h3>
                <div className="overflow-x-auto">
                    <Table>
                        <Table.Head>
                            <Table.HeadCell>S.No</Table.HeadCell>
                            <Table.HeadCell>Staff Name</Table.HeadCell>
                            <Table.HeadCell>Request Reason</Table.HeadCell>
                            <Table.HeadCell>Request At</Table.HeadCell>
                            <Table.HeadCell>Status</Table.HeadCell>
                            <Table.HeadCell>Reject/Accept At</Table.HeadCell>
                            <Table.HeadCell>Reject Reason</Table.HeadCell>
                        </Table.Head>
                        <Table.Body className="divide-y">
                            {requestActivityData.length > 0 ? requestActivityData.map((item, index) => (
                                <Table.Row key={item.request_id} className="bg-white">
                                    <Table.Cell>{index + 1}</Table.Cell>
                                    <Table.Cell>{item.staff_name}</Table.Cell>
                                    <Table.Cell>{item.request_reason}</Table.Cell>

                                    <Table.Cell>
                                        {new Date(item.request_date_time).toLocaleString('en-GB', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            second: '2-digit',
                                            hour12: false
                                        })}
                                    </Table.Cell>

                                    <Table.Cell>
                                        {item.accept_reject_state === "rejected" && <Badge color="failure">Rejected</Badge>}
                                        {item.accept_reject_state === "requested" && <Badge color="warning">Requested</Badge>}
                                        {item.accept_reject_state === "accepted" && <Badge color="success">Accepted</Badge>}
                                    </Table.Cell>

                                    <Table.Cell>
                                        {item.accept_date_time
                                            ? new Date(item.accept_date_time).toLocaleString('en-GB', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                second: '2-digit',
                                                hour12: false
                                            })
                                            : ""}
                                    </Table.Cell>

                                    <Table.Cell>
                                        {item.reject_reason || "N/A"}
                                    </Table.Cell>
                                </Table.Row>
                            )) :
                                <Table.Row  className="bg-white text-center">
                                    <Table.Cell  colspan={7}>No data available</Table.Cell>
                                </Table.Row>
                            }
                        </Table.Body>
                    </Table>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default RequestActivityModal;

// Usage Example:
// <RequestActivityModal
//     show={requestActivityModal}
//     onClose={() => setrequestActivityModal(false)}
//     requestActivityData={requestActivityData}
// />
